/**
 * An inline, asset-free "screenshot" of the product dashboard. Built from live
 * DOM + design tokens rather than a hosted image, so it (a) stays inside the
 * strict CSP (img-src allows only 'self'/data:, and we ship no external files),
 * (b) re-skins with the brand accent, and (c) renders crisp on any display.
 * The figures are illustrative sample data, labelled as such for honesty.
 */
export function ProductPreview() {
  return (
    <figure className="mk-preview" aria-label="Ledgerline dashboard preview">
      <div className="mk-preview-bar">
        <span className="dot" />
        <span className="dot" />
        <span className="dot" />
        <span className="mk-preview-title">/app/dashboard — consolidated</span>
      </div>
      <div className="mk-preview-body">
        <span className="mk-tie">
          <span className="dot" /> Trial balance ties out — Dr = Cr
        </span>
        <div className="mk-kpis">
          <div className="mk-kpi">
            <div className="k-label">Cash &amp; bank</div>
            <div className="k-value">1,284,900</div>
          </div>
          <div className="mk-kpi">
            <div className="k-label">Net profit (YTD)</div>
            <div className="k-value">412,350</div>
          </div>
          <div className="mk-kpi">
            <div className="k-label">VAT payable</div>
            <div className="k-value">63,120</div>
          </div>
        </div>
        <div className="mk-rows" aria-hidden="true">
          <div className="r">
            <span>Sales — Meridian Trading FZ-LLC</span>
            <span className="amt">AED</span>
            <span className="amt">918,000</span>
          </div>
          <div className="r">
            <span>Cost of goods sold</span>
            <span className="amt">AED</span>
            <span className="amt">(505,650)</span>
          </div>
          <div className="r">
            <span>FX gain / (loss) — USD bills</span>
            <span className="amt">AED</span>
            <span className="amt">2,140</span>
          </div>
        </div>
      </div>
    </figure>
  );
}
